export default __webpack_public_path__ + "static/media/document-copy.8bdd2b95.svg";